import { useEffect } from 'react';

import { Button } from '@components/button';
import { triggerConfetti } from '@components/confetti/provider';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { PreboardingPage } from './common';

import { useNextStep } from '../navigation';

export const CompanyGetStartedPage = () => {
  const { t, styledTranslate } = useScopedTranslate(locale);
  const navigateToNextStep = useNextStep();

  useEffect(triggerConfetti, []);

  const handleContinue = () => {
    navigateToNextStep();
  };

  return (
    <PreboardingPage>
      <div>
        <Text text={t('title')} font="heading1" center />
        <Text
          text={styledTranslate('subtitle', {
            everything: { color: 'blue100', text: t('everything'), font: 'bold16' },
          })}
          font="regular16"
          center
        />
      </div>
      <Button variant="primary-blue" onClick={handleContinue}>
        {t('getStarted')}
      </Button>
    </PreboardingPage>
  );
};

const locale = {
  en: {
    title: 'Welcome to Journeys 🎉',
    subtitle: 'A visual, no-code workflow platform that integrates with {everything}',
    everything: 'everything',
    getStarted: 'Get started',
  },
};
